/**
 * @fileoverview GET handler for the "/apps/user_info/merge_duplicate_users_rules" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsUserInfoMergeDuplicateUsersRules } from "./constants";
import type { AppsUserInfoMergeDuplicateUsersRulesResult } from "./types";

export const getAppsUserInfoMergeDuplicateUsersRules = reactQueryFetcherAdapter(
  appsUserInfoMergeDuplicateUsersRules,
  (signal: AbortSignal): Promise<AppsUserInfoMergeDuplicateUsersRulesResult> => {
    return fetch("/apps/user_info/merge_duplicate_users_rules", "GET", {}, { signal });
  }
);
